const guideGen62 = [
  "Uhr einstellen",
  "Ins Haus der Rivalin gehen (und die Treppe hoch)",
  "Route 101 – Starter-Pokémon erhalten",
  "Rosalstadt besuchen",
  "Route 103 – Rivalen-Kampf",
  "Zurück nach Wurzelheim Pokebälle abholen",
  "Blütenburg City – Besuch beim Vater",
  "Route 104 & Blütenburgwald durchqueren",
  "Metarost City – 1. Arena (Gestein)",
  "Route 116 & Metaflurtunnel",
  "Route 109 & Faustauhaven – 2. Arena (Kampf)",
  "Granithöhle & Route 106",
  "Graphitport City – Devon-Mitarbeiter treffen",
  "Route 110 – Kampf gegen Rivalen",
  "Malvenfroh City – 3. Arena (Elektro)",
  "Route 111 & Wüste (optional mit Go-Goggles)",
  "Route 112 & Fiery Path",
  "Laubwechselfeld – 4. Arena (Feuer)",
  "Route 113 – Ascheweg",
  "Laubwechselfeld & Meteoriten-Story",
  "Route 114 & Meteor-Fälle",
  "Zurück nach Laubwechselfeld & Storyfortschritt",
  "Route 115 & Seegrasulb City – 5. Arena (Normal)",
  "Route 118 & 119 – Wetter-Institut",
  "Baumhausen City – 6. Arena (Flug)",
  "Route 120 & 121 – Team Aqua aufhalten",
  "Lillycove City – großes Kaufhaus",
  "Versteck von Team Aqua & U-Boot-Story",
  "Route 124 & 126 – Xeneroville",
  "Xeneroville – 7. Arena (Psycho)",
  "Route 128 – Team Aqua aufhalten",
  "Urzeithöhle & Proto-Groudon/Kyogre",
  "Pokémon-Liga vorbereiten",
  "Route 129–130 – Siegesstraße",
  "Pokémon Liga – Top 4 & Champ",
];

export default guideGen62;
